import React from 'react'
import { Box, Button, Modal } from '@material-ui/core'
import { DatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers'
import DateFnsUtils from '@date-io/date-fns'
import frLocale from 'date-fns/locale/fr'
import { useDataProvider } from 'react-admin'
import { ACTIONS } from '../providers/http/provider'

const ExportModal = ({ type, handleClose }) => {
  const [selectedStartDate, handleStartDateChange] = React.useState(new Date())
  const [selectedEndDate, handleEndDateChange] = React.useState(new Date())
  const dataProvider = useDataProvider()

  const handleCsvDownload = () => {
    if (type === 'club') {
      dataProvider(ACTIONS.GET_BINARY, 'clubs/csv')
        .then()
        .catch()
        .finally(() => handleClose())
    }
    if (type === 'users') {
      dataProvider(ACTIONS.GET_BINARY, 'users/csv')
        .then()
        .catch()
        .finally(() => handleClose())
    }
    if (type === 'player') {
      dataProvider(
        ACTIONS.GET_BINARY,
        `tournaments/players/csv/${selectedStartDate.toISOString().split('T')[0]}/${
          selectedEndDate.toISOString().split('T')[0]
        }`
      )
        .then()
        .catch()
        .finally(() => handleClose())
    }
    if (type === 'tournament') {
      dataProvider(
        ACTIONS.GET_BINARY,
        `tournaments/csv/${selectedStartDate.toISOString().split('T')[0]}/${
          selectedEndDate.toISOString().split('T')[0]
        }`
      )
        .then()
        .catch()
        .finally(() => handleClose())
      handleClose()
    }
  }

  return (
    <Modal
      aria-labelledby="unstyled-modal-title"
      aria-describedby="unstyled-modal-description"
      open={type !== null}
      onClose={handleClose}
      style={{
        position: 'fixed',
        zIndex: 1300,
        right: 0,
        bottom: 0,
        top: 0,
        left: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Box
        style={{
          backgroundColor: 'white',
          borderRadius: 8,
          padding: 40,
          display: 'flex',
          flexDirection: 'column',
          minWidth: 400,
        }}
      >
        {' '}
        {type === 'tournament' || type === 'player' ? (
          <>
            <MuiPickersUtilsProvider utils={DateFnsUtils} locale={frLocale}>
              <DatePicker
                variant="inline"
                label="Date de début"
                value={selectedStartDate}
                onChange={handleStartDateChange}
                format="dd/MM/yyyy"
                ampm={false}
              />
              <DatePicker
                variant="inline"
                label="Date de fin"
                value={selectedEndDate}
                onChange={handleEndDateChange}
                style={{ marginTop: 20 }}
                format="dd/MM/yyyy"
                ampm={false}
              />
            </MuiPickersUtilsProvider>
          </>
        ) : null}
        <Button color="primary" style={{ marginTop: 20 }} onClick={() => handleCsvDownload()}>
          Exporter
        </Button>
      </Box>
    </Modal>
  )
}

export default ExportModal
